export default __webpack_public_path__ + "static/media/brett-2.bbe25e38.jpg";